<template>
  <div class="box-tat">
    <div class="pd-x-4">
      <h4 class="color-white text-font-18 mg-less">
        e-Learning by AvocadoX
      </h4>
      <p class="text-font-16 color-white">
        {{ type == "signin" ? "คุณเป็นสมาชิกอยู่แล้ว?" : "คุณเป็นสมาชิกใหม่?" }}
      </p>
      <div>
        <el-button
          @click="
            type == 'signin' ? $router.push('/signin') : $router.push('/signup')
          "
          round
          class="primary pd-x-1 text-weight-600 text-font-20 button-auth"
          >{{
            type == "signin" ? "เข้าสู่ระบบเรียนออนไลน์" : "ลงทะเบียนออนไลน์"
          }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default() {
        return "signin";
      },
    },
  }
};
</script>
<style  scoped>
.text-font-20 {
  font-size: 20px !important;
}
</style>